/**
 * s236 (D-236.46; findings item 45) — ONE ROW'S SAVES GO OUT ONE AT A TIME.
 *
 * A contact card's name commits twice when its box loses focus — `{ display }` at once, then `{ display, ref }` a tick
 * later once the contact resolves (ContactInput never makes the save wait on the mint). Sent side by side, the two
 * requests for a NEW cell each found nothing and each inserted, and one failed: "Couldn't save that" (staging,
 * 2026-10-02 16:38:05Z and 16:39:04Z). Queued per row, the second request starts only when the first has landed, so it
 * finds the first one's cell and updates it.
 *
 * The queue is module-wide, keyed by client + section + row, so two components writing the same row share it. A failed
 * save does not block the next one — each caller still gets its own result, and the red pop-up stays the caller's.
 * Different rows never wait on each other.
 */
const tails = new Map<string, Promise<unknown>>();

export const rowSaveKey = (clientId: string, sectionId: string | undefined, rowId: string | null | undefined) =>
  `${clientId}|${sectionId ?? ""}|${rowId ?? ""}`;

export function queueRowSave<T>(key: string, save: () => Promise<T>): Promise<T> {
  const previous = tails.get(key) ?? Promise.resolve();
  const next = previous.then(save, save);
  const tail = next.then(() => undefined, () => undefined);
  tails.set(key, tail);
  void tail.then(() => {
    if (tails.get(key) === tail) tails.delete(key);
  });
  return next;
}
